/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Microsoftdomainforlogin3Inputs */



/**

* @param {_Field_Microsoftdomainforlogin3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_microsoftdomainforlogin3 = /** @type {((inputs?: _Field_Microsoftdomainforlogin3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Microsoftdomainforlogin3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Microsoft Domain für Anmeldenamen")
});
export { _field_microsoftdomainforlogin3 as "_field_microsoftDomainForLogin" }